import {
  AuthnTransaction,
  EVENT_ADDED,
  EVENT_EXPIRED,
  EVENT_REMOVED,
  Token,
  TokenManagerEventHandler
} from '@okta/okta-auth-js';

export class BypassAuth {
  oktaAuth: any;
  config: any;
  //see TokenManagerInterface for all methods available on tokenManager
  tokenManager: {
    renew: (key: string) => Promise<Token | undefined>;
    hasExpired: (token: Token) => boolean;
    on: (
      event: typeof EVENT_EXPIRED | typeof EVENT_ADDED | typeof EVENT_REMOVED,
      handler: TokenManagerEventHandler,
      context?: object
    ) => void;
  };

  constructor(config: any) {
    this.config = config;
    this.tokenManager = {
      renew: async (key: string): Promise<Token | undefined> =>
        Promise.resolve({
          accessToken: '1234',
          expiresAt: 9999999999,
          scopes: ['openid', 'profile', 'email'],
          tokenType: 'Bearer',
          authorizeUrl: 'https://mock-authorize-url',
          userinfoUrl: 'https://mock-userinfo-url',
          claims: {
            sub: 'mockSub',
            name: 'Mock User',
            email: 'mockuser@example.com'
          }
        }),
      hasExpired: (token: Token) => false,
      on: async (
        event: typeof EVENT_EXPIRED | typeof EVENT_ADDED | typeof EVENT_REMOVED,
        handler: TokenManagerEventHandler,
        context?: object
      ) => {}
    };
  }

  async mockLogin(): Promise<void> {}

  async isAuthenticated(): Promise<boolean> {
    return Promise.resolve(true);
  }

  getAccessToken(): string {
    return '123';
  }
  getIdToken(): string {
    return '456';
  }

  async getOrRenewAccessToken(): Promise<string | null> {
    return Promise.resolve('1234');
  }

  async signOut(options: any): Promise<void> {
    Promise.resolve();
  }
  async signInWithCredentials(options: any): Promise<AuthnTransaction> {
    return {status: 'SUCCESS'};
  }
  async signInWithRedirect(options: any): Promise<void> {
    Promise.resolve();
  }
  async forgotPassword(options: any): Promise<AuthnTransaction> {
    return {status: 'SUCCESS'};
  }

  async verifyRecoveryToken(options: any): Promise<AuthnTransaction> {
    return {status: 'SUCCESS'};
  }

  async unlockAccount(options: any): Promise<AuthnTransaction> {
    return {status: 'SUCCESS'};
  }
}
